import {
  BtlPropertyTypeEnum,
  ProductTypeEnum,
  ProductTierEnum,
  ProductRangeEnum,
  ProductCategoryEnum,
} from '../../legacy/shared-types';
import { useIntl } from 'react-intl';

export const useFormSelectOptions = () => {
  const intl = useIntl();

  const productRangeOptions = [
    {
      value: ProductRangeEnum.Iman,
      label: intl.formatMessage({ id: 'product.productRange.iman.label' }),
    },
    {
      value: ProductRangeEnum.IncomeMax,
      label: intl.formatMessage({ id: 'product.productRange.incomeMax.label' }),
    },
    {
      value: ProductRangeEnum.BrokerExclusive,
      label: intl.formatMessage({ id: 'product.productRange.brokerExclusive.label' }),
    },
  ];

  const productCategoryOptions = [
    {
      value: ProductCategoryEnum.OWNER_OCCUPIED,
      label: intl.formatMessage({ id: 'product.productCategory.ownerOccupied.label' }),
    },
    {
      value: ProductCategoryEnum.BUY_TO_LET,
      label: intl.formatMessage({ id: 'product.productCategory.buyToLet.label' }),
    },
  ];

  const productTypeOptions = [
    { value: ProductTypeEnum.FIXED, label: intl.formatMessage({ id: 'product.productType.fixed.label' }) },
    { value: ProductTypeEnum.DISCOUNT, label: intl.formatMessage({ id: 'product.productType.discount.label' }) },
  ];

  const productPoolOptions = [
    { value: ProductTierEnum.TIER_1, label: intl.formatMessage({ id: 'product.tier_1.label' }) },
    { value: ProductTierEnum.TIER_2, label: intl.formatMessage({ id: 'product.tier_2.label' }) },
  ];

  const btlExpatOptions = [
    { value: true, label: intl.formatMessage({ id: 'common.yes' }) },
    { value: false, label: intl.formatMessage({ id: 'common.no' }) },
  ];

  const propertyCategoryOptions = [
    {
      value: BtlPropertyTypeEnum.STANDARD,
      label: intl.formatMessage({ id: 'product.propertyCategory.standard.label' }),
    },
    {
      value: BtlPropertyTypeEnum.HMO_OR_MUB,
      label: intl.formatMessage({ id: 'product.propertyCategory.hmoOrMub.label' }),
    },
  ];

  return {
    productRangeOptions,
    productTypeOptions,
    productPoolOptions,
    productCategoryOptions,
    btlExpatOptions,
    propertyCategoryOptions,
  };
};
